<template>
	<header-block :del="true" @delete="deleteAccount" :title="'Mortgage'" :edit="'/Mortgages/Edit/' + this.$route.params.id"></header-block>
	<CustomerLoadWait :customer="policy" />
	<transition>
		<div v-if="policy">
			<WellPanel 
				:title="policy.account.provider.name" 
				subTitle="Provider"
				:avatarLetter="policy.account.provider.name.charAt(0)"
				:data="wellData"
			/>
			
		</div>
	</transition>
	<DrawerPanel v-if="documents && documents.length > 0" bottom="-18px" openHeight="450px" title="Saved documents" backgroundColor="white" openBackgroundColor="white">
		<div class="docsPanel" v-if="documents">
			<a v-for="d in documents" :key="d.id" :href="d.url">
				<v-row>
					<v-col cols="1"><v-icon class="docIcon" icon="mdi-file-document-outline"></v-icon></v-col>
					<v-col class="docCol">{{ d.name }}<br/><span></span></v-col>
					<v-col cols="1" class="arrowCol"><img class="arrow" src="../assets/arrow-right.png" /></v-col>
				</v-row>
			</a>
		</div>
	</DrawerPanel>
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import WellPanel from './elements/WellPanel.vue';

export default {
	mixins: [Services],
	components: {CustomerLoadWait, HeaderBlock, WellPanel, DrawerPanel},
	data() {
		return {
			policyId: null,
			wellData: []
		}
	},
	methods: {
		onLoad: async function() {
			this.policyId = this.$route.params.id;
			this._getCustomer();
			this._getMortgage(this.policyId, () => {
				const address = this.policy.address ? 
					[this.policy.address.line1, this.policy.address.line2, this.policy.address.line3, this.policy.address.town, this.policy.address.postCode].filter(Boolean).join(', ') : 
					'';
				this.wellData = [
					{order: 1, label: 'Sole or joint', value: this.policy.account.jointStatus === 0 ? 'Sole' : 'Joint'},
					{order: 2, label: 'Account number', value: this.policy.account.reference},
					{order: 3, label: 'Address', value: address},
					{order: 4, label: 'Current balance', value: this.formatter.format(this.policy.account.balance.amount)},
					{order: 5, label: 'Monthly repayment', value: this.formatter.format(this.policy.monthlyRepaymentAmount)},
					{order: 6, label: 'Original term', value: this.policy.account.termMonths / 12 + ' years'},
					{order: 7, label: 'Type', value: this._getInterestRateType(this.policy.interestRateType)},
					{order: 8, label: 'Deal rate', value: this.policy.dealRate + '%'},
					{order: 9, label: `Promotion expiry | in ${this._calculateMonthsRemaining(this.policy.dealEndDate)} months`, value: this.dateFormatPretty.format(new Date(this.policy.dealEndDate)), progress: this._calculateDateProgressPercentage(this.policy.account.creditCreateDate, this.policy.dealEndDate)},
				];
				this._getDocumentsByHubId(this.policy.id);
			});
		},		
		deleteAccount: function(){
			this._deleteMortgageAccount(this.$route.params.id, () => {
				this._getCreditInfo(/*onSuccess*/ null, /*refreshCache*/ true);
				this._getMortgageInfo(/*onSuccess*/ null, /*refreshCache*/ true);
				this.$router.push('/money');
			});
		},
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

.docsPanel {
	padding-right: 20px;
}

.docIcon {
	c--olor: var(--grey-text);
}

.docCol {
	font-size: 14px;
	c--olor: var(--grey-text);
}

.arrowCol {
	padding-top: 15px;
}

.arrow {
	width: 18px;
	
}

</style>
